// extracted by mini-css-extract-plugin
export default {"activeLink":"NotificationButton_activeLink__rCtbY","link":"NotificationButton_link__qvT9G","counter":"NotificationButton_counter__g4gZf"};